// Environment variable utility that works in both Vite and Jest
// see [documentation/configuration.md](documentation/configuration.md#client-side-environment-variables) for more details

interface FirebaseConfig {
  apiKey: string | undefined;
  authDomain: string | undefined;
  databaseURL: string | undefined;
  projectId: string | undefined;
  storageBucket: string | undefined;
  messagingSenderId: string | undefined;
  appId: string | undefined;
  measurementId: string | undefined;
}

const getEnvVar = (key: string): string | undefined => {
  // vite uses vite-plugin-environment to pass import.meta.env to process.env
  // process configured in vite.config.js
  const processEnv = process;
  return processEnv.env[key];
};

// Special function for Firebase config that uses the defined config object
const getFirebaseConfig = (): FirebaseConfig => {
  return {
    apiKey: getEnvVar('VITE_FIREBASE_API_KEY'),
    authDomain: getEnvVar('VITE_FIREBASE_AUTH_DOMAIN'),
    databaseURL: getEnvVar('VITE_FIREBASE_AUTH_DBURL'),
    projectId: getEnvVar('VITE_FIREBASE_PROJECT_ID'),
    storageBucket: getEnvVar('VITE_FIREBASE_STORAGE_BUCKET'),
    messagingSenderId: getEnvVar('VITE_FIREBASE_MESSAGING_SENDER_ID'),
    appId: getEnvVar('VITE_FIREBASE_APP_ID'),
    measurementId: getEnvVar('VITE_FIREBASE_MEASUREMENT_ID'),
  };
};

export { getEnvVar, getFirebaseConfig };
export type { FirebaseConfig };
